var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 96 96",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface934465"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(50.196081%,87.058824%,91.764706%)",
      fillOpacity: 1
    },
    d: "M 48 68 C 22.199219 68 2 59.199219 2 48 C 2 36.800781 22.199219 28 48 28 C 73.800781 28 94 36.800781 94 48 C 94 59.199219 73.800781 68 48 68 Z M 48 32 C 22.800781 32 6 40.199219 6 48 C 6 55.800781 22.800781 64 48 64 C 73.199219 64 90 55.800781 90 48 C 90 40.199219 73.199219 32 48 32 Z M 48 32 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(50.196081%,87.058824%,91.764706%)",
      fillOpacity: 1
    },
    d: "M 30.199219 89.199219 C 28.199219 89.199219 26.601562 88.800781 25 87.800781 C 15.199219 82.199219 17.800781 60.398438 30.601562 38 C 36.601562 27.601562 44 18.800781 51.199219 13.199219 C 59 7.199219 66 5.398438 70.800781 8.199219 C 75.800781 11 77.601562 18 76.398438 27.800781 C 75.199219 37 71.199219 47.800781 65.199219 58.199219 C 59.199219 68.601562 51.800781 77.398438 44.601562 83 C 39.398438 87 34.398438 89.199219 30.199219 89.199219 Z M 65.800781 10.800781 C 62.601562 10.800781 58.398438 12.601562 53.800781 16.199219 C 47 21.601562 40 30 34.199219 40 C 21.601562 61.800781 20.398438 80.601562 27 84.398438 C 30.398438 86.398438 36 84.601562 42.199219 79.800781 C 49 74.398438 56 66 61.800781 56 C 67.601562 46 71.398438 35.800781 72.601562 27.199219 C 73.601562 19.199219 72.398438 13.601562 69 11.601562 C 68 11.199219 67 10.800781 65.800781 10.800781 Z M 65.800781 10.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(50.196081%,87.058824%,91.764706%)",
      fillOpacity: 1
    },
    d: "M 66 89.199219 C 56 89.199219 41.601562 77 30.800781 58 C 17.800781 35.601562 15.199219 13.800781 25 8.199219 C 34.800781 2.601562 52.398438 15.601562 65.398438 38 C 71.398438 48.398438 75.398438 59.199219 76.601562 68.398438 C 78 78.199219 76 85 71 88 C 69.398438 88.800781 67.800781 89.199219 66 89.199219 Z M 27 11.601562 C 20.398438 15.398438 21.601562 34.199219 34.199219 56 C 46.800781 77.800781 62.398438 88.199219 69 84.398438 C 72.398438 82.398438 73.601562 76.800781 72.601562 68.800781 C 71.398438 60.199219 67.601562 50 61.800781 40 C 49.199219 18.199219 33.601562 7.800781 27 11.601562 Z M 27 11.601562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(50.196081%,87.058824%,91.764706%)",
      fillOpacity: 1
    },
    d: "M 56 48 C 56 52.417969 52.417969 56 48 56 C 43.582031 56 40 52.417969 40 48 C 40 43.582031 43.582031 40 48 40 C 52.417969 40 56 43.582031 56 48 Z M 56 48 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.109605227b804b2bbe955a22bd4fac25.svg";
export { ForwardRef as ReactComponent };